<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="100px"
    class="material-img"
  >
    <el-form-item
      label="新媒体文件"
      prop="imgUrl"
    >
      <div class="avatar-box">
        <el-upload
          class="avatar-uploader"
          action="''"
          :show-file-list="false"
          :http-request="uploadImgUrlHandle"
          :before-upload="beforeAvatarUpload"
          v-loading="uploadLoading"
        >
          <img
            v-if="form.imgUrl"
            class="avatar-img"
            :src="form.imgUrl"
          />
          <div
            v-if="!form.imgUrl"
            class="avatar-uploader-btn pointer">
            <i class="el-icon-plus add-btn-el"></i>
          </div>
          <div class="cover-box">
            <div class="zoom-btn">
              <i class="el-icon-zoom-in"></i>
            </div>
            <div class="delete-box">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </el-upload>
      </div>
    </el-form-item>
    <el-form-item
      label="媒体类型"
      prop="mediaType"
    >
      <el-select
        v-model="form.mediaType"
        placeholder="媒体类型"
        style="width:100%"
        disabled
      >
<!--        \GIF-->
        <el-option
          label="图片（2M以内，支持PNG\JPEG\JPG）"
          value="image"
        ></el-option>
        <el-option
          label="视频（10M以内，只支持MP4）"
          value="video"
        ></el-option>
        <el-option
          label="语音（2M、60s以内，支持AMR\MP3）"
          value="voice"
        ></el-option>
        <el-option
          label="缩略图（64K以内JPG）"
          value="thumb"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="素材名称"
      prop="fileName"
    >
      <el-input
        v-model="form.fileName"
        placeholder="为便于管理建议按用途分类+素材内容命名"
      ></el-input>
    </el-form-item>
    <el-dialog
      :visible.sync="dialogVisible"
    >
      <img width="100%"
           :src="dialogImageUrl"
           alt="">
    </el-dialog>
  </el-form>
</template>

<script>
import { limitImageSizeFormat } from "@/utils/common";
let origin = {
  imgUrl: '',
  mediaType: 'image',
  fileName: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "materialImgForm",
  components: {
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        imgUrl: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        mediaType: [
          // { required:true, message: '请选择', trigger: 'change' },
        ],
        fileName: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
      },
      uploadLoading: false,
      dialogVisible: false,
      dialogImageUrl: '',

      file: '',//文件
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          // this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  created(){
  },
  methods: {
    // 上传的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadImgUrlHandle(item){
      console.log(item.file);
      this.file = item.file;
      this.form.fileName = item.file.name.substring(0, item.file.name.lastIndexOf('.'))

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.uploadLoading = true;
        this.$uploadFile(file).then((rs) => {
          this.uploadLoading = false;
          this.form.imgUrl = rs.data.url;
        }).catch((err) => {
          this.uploadLoading = false;
        })
      });

    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo
    handlePictureCardPreview(){
      this.dialogImageUrl = this.form.imgUrl;
    },
    handleRemove(){
      this.form.imgUrl = '';
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form,this.file);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.material-img {
  .avatar-box {
    display: inline-block;
    position: relative;
    .avatar-uploader-btn {
      width: 80px;
      height: 80px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 2px solid #D8D6DE;
    }
    .avatar-img {
      width: 80px;
      height: 80px;
    }
    .cover-box {
      position: absolute;
      width: 80px;
      height: 80px;
      bottom: 0;
      right: 0;
      background-color: rgba(0,0,0,.5);
      display: flex;
      justify-content: center;
      align-items: center;
      display: none;
    }
  }
}
</style>
